module.exports = __webpack_public_path__ + "14e6d56f75bf1fe24ea9d9b00ad20fe1.png";